<template>
  <div v-if="visible" class="interventions">
    <ncs-empty-result v-if="emptyResult"/>
    <template v-else>
      <ncs-page-selector/>
      <div @scroll="scrollTop" ref="scrollTop" class="scroll-top">
        <div ref="scrollTopContent"></div>
      </div>
      <div class="table-responsive" @scroll="scrollBottom" ref="scrollBottom">
        <table class="table table-striped table-borderless table-sm">
          <tbody ref="tableBody">
          <tr v-for="(row, index) in result.interventions" class="interventions-row">
            <td class="interventions-header">
              <a @click.prevent="showContext(row, index)"
                 href="#"
                 class="context-link"
                 v-html="$fn(currentOffset + index + 1)"></a>
              <ncs-kwic-result-header :document="row.document" :text="row.text" :elements="row.elements"
                                      :matches="row.matches"/>
            </td>
            <td>
              <span v-for="element in row.elements" :class="$ncsElementClass(element, false)"
                    :title="$ncsElementTitle(element)"
                    v-html="$ncsElementContent(element)"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    mounted() {
      this.initScroll()
    },
    updated() {
      this.initScroll()
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'interventions',
        executionState: s => s.api.executionState,
        result: s => s.api.result,
        currentOffset: s => s.pagination.currentOffset
      }),
      emptyResult() {
        return this.result.pagination.rows === 0
      },
      header() {
        if (this.result.interventions.length === 0) {
          return []
        } else {
          return Object.keys(this.result.interventions[0]).filter(e => e !== 'id')
        }
      }
    },
    methods: {
      initScroll() {
        // We have to check the execution state and result type, because we need to update scroll HTML
        // with every render, and it can happen even if the component dom is not rendered.
        // For example, when we access context api state changes and, since it's bound to this component
        // through computed properties, the updated hook will be called, but the component is not rendered.
        // Pressing back button will restore previous result and update hook will be called. This time the
        // component will be rendered and we have to initialize the top scroll again.
        if (this.visible && this.executionState === "completed" && !this.emptyResult) {
          this.$refs.scrollTopContent.style.width = `${this.$refs.tableBody.scrollWidth}px`
        }
      },
      scrollTop() {
        this.$refs.scrollBottom.scrollLeft = this.$refs.scrollTop.scrollLeft
      },
      scrollBottom() {
        this.$refs.scrollTop.scrollLeft = this.$refs.scrollBottom.scrollLeft
      },
      showContext(row, index) {
        const query = {document: row.document.id, uncached: { text: row.text.id, example: index + 1 }}
        this.$store.dispatch('api/executeDetail', { type: 'intervention', query})
        window.document.dispatchEvent(new CustomEvent('ncs-search', {
          detail: { resultType: this.resultType, action: 'search' }
        }))
      }

    }
  }
</script>
